import { useNavigate } from "react-router-dom";
import moment from "moment";
import { emptyCheck, maskMiddleCharacters } from "util/function/function";

// 디자인 토큰 — desktop 카드와 동일 팔레트
const C = {
  green: "#059669",
  greenDark: "#047857",
  greenBg: "#ECFDF5",
  greenBorder: "#A7F3D0",
  ink: "#111827",
  body: "#374151",
  sub: "#6B7280",
  line: "#E5E7EB",
  amber100: "#FEF3C7",
  amber800: "#92400E",
};

const statusMap = {
  0: { label: "매칭중", bg: C.amber100, fg: C.amber800, dot: "#F59E0B" },
  1: { label: "매칭완료", bg: "#DBEAFE", fg: "#1E40AF", dot: "#3B82F6" },
  2: { label: "완료", bg: C.greenBg, fg: C.greenDark, dot: C.green },
};

function StatusChip({ status }) {
  const s = statusMap[status] ?? statusMap[0];
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: "4px 10px",
        borderRadius: 9999,
        background: s.bg,
        color: s.fg,
        fontSize: 11,
        fontWeight: 700,
        lineHeight: 1.2,
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ width: 5, height: 5, borderRadius: 9999, background: s.dot, flexShrink: 0 }} />
      {s.label}
    </span>
  );
}

const categoryEmoji = (name = "") => {
  const s = String(name);
  if (s.includes("트랙터")) return "🚜";
  if (s.includes("콤바인")) return "🌾";
  if (s.includes("제어기") || s.includes("전자") || s.includes("전기")) return "⚡";
  if (s.includes("엔진") || s.includes("모터")) return "⚙️";
  if (s.includes("배터리")) return "🔋";
  if (s.includes("오일") || s.includes("연료")) return "🛢️";
  if (s.includes("이앙기") || s.includes("파종")) return "🌱";
  if (s.includes("바퀴") || s.includes("타이어")) return "⚫";
  return "🔧";
};

const relativeTime = (dateStr) => {
  if (!dateStr) return "";
  const m = moment(dateStr);
  if (!m.isValid()) return "";
  const diffMin = moment().diff(m, "minutes");
  if (diffMin < 1) return "방금 전";
  if (diffMin < 60) return `${diffMin}분 전`;
  const diffHr = moment().diff(m, "hours");
  if (diffHr < 24) return `${diffHr}시간 전`;
  const diffDay = moment().diff(m, "days");
  if (diffDay < 7) return `${diffDay}일 전`;
  return m.format("YYYY.MM.DD");
};

const MatchingItemMobile = ({ repair }) => {
  const navigate = useNavigate();
  const names = repair?.categoryListName ?? [];
  const primary = names[0] || "기타";
  const secondary = names.slice(1).filter((n) => n && n !== "기타").join(" · ");
  const emoji = categoryEmoji(primary);
  const images = Array.isArray(repair?.imageUrls) ? repair.imageUrls : [];
  const firstImage = images[0];
  const expertName = !emptyCheck(repair?.expertName) ? repair.expertName : null;
  const statusStr = repair?.status;

  return (
    <div
      onClick={() => navigate(`${repair.docId}`)}
      style={{
        display: "flex",
        gap: 12,
        padding: 14,
        background: "#fff",
        border: `1px solid ${C.line}`,
        borderRadius: 12,
        cursor: "pointer",
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: 10,
          background: firstImage ? "#F3F4F6" : C.greenBg,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 26,
          position: "relative",
          overflow: "hidden",
        }}
      >
        {firstImage ? (
          <img src={firstImage} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        ) : (
          <span>{emoji}</span>
        )}
        {images.length > 1 && (
          <span
            style={{
              position: "absolute",
              bottom: 2,
              right: 2,
              background: "rgba(17,24,39,0.75)",
              color: "#fff",
              fontSize: 9,
              fontWeight: 700,
              padding: "1px 5px",
              borderRadius: 5,
            }}
          >
            +{images.length - 1}
          </span>
        )}
      </div>

      <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 4 }}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: C.ink,
              letterSpacing: "-0.01em",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              flex: 1,
              minWidth: 0,
            }}
          >
            {primary}
            {secondary && <span style={{ color: C.sub, fontWeight: 500 }}> · {secondary}</span>}
          </div>
          <StatusChip status={statusStr} />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 11,
            color: C.sub,
            flexWrap: "wrap",
          }}
        >
          <span>{relativeTime(repair?.createDate)}</span>
          <span style={{ width: 2, height: 2, background: "#D1D5DB", borderRadius: 9999 }} />
          <span>
            {String(statusStr) === "1" && expertName
              ? `${maskMiddleCharacters(expertName)} 배정`
              : String(statusStr) === "0"
              ? "배정 대기"
              : String(statusStr) === "2"
              ? "수리 완료"
              : "-"}
          </span>
          {images.length > 0 && (
            <>
              <span style={{ width: 2, height: 2, background: "#D1D5DB", borderRadius: 9999 }} />
              <span>사진 {images.length}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MatchingItemMobile;
